export const maxSymbols = 1024;
